module.exports = __webpack_public_path__ + "img/home.95665575.svg";